import { rulerTool } from './rulerTool';
import { areaTool } from './areaTool';
import { coordsTool } from './coordsTool';
import { useMeasurementTools } from './useMeasurementTools';

export const measurementTools = {
    'measure-ruler': rulerTool,
    'measure-area': areaTool,
    'measure-coords': coordsTool,
};

export { useMeasurementTools };